import cc from "classcat"

const BlogBox = ({ children, bg }) => {
  return (
    <aside
      className={cc([
        "blog-box mb-12 space-y-4 rounded-lg p-8 text-zinc-900 shadow-xl ",
        bg || "bg-teal-100",
      ])}
    >
      {children}
    </aside>
  )
}

export default BlogBox
